import request from '@/utils/request'

// 加载 

export function loadnews(params) {
    return request({
        url: '/api/CmsArticle/LoadQT',
        method: 'get',
        params
    })
}

export function HomeGetNewMes(params) {
    return request({
        url: '/api/Home/GetNewMes',
        method: 'get',
        params
    })
}

export function HomeGetNewMesList(params) {
    return request({
        url: '/api/Home/GetNewMesList',
        method: 'get',
        params
    })
}

// 获取单个数据
export function GetNews(params) {
    return request({
        url: '/api/CmsArticle/Get',
        method: 'get',
        params
    })
}

//门户新闻图片接口
export function Gethomeimglist(params) {
    return request({
        url: '/api/Home/GetPicNewList',
        method: 'get',
        params
    })
}
//门户新闻文字接口
export function Gethometextlist(params) {
    return request({
        url: '/api/Home/GetNewList',
        method: 'get',
        params
    })
}

export function CmsNavigationGetList(params) {
    return request({
        url: '/api/CmsNavigation/GetList',
        method: 'get',
        params
    })
}




//通过字典id查询数据
export function getPmiDic(params) {
    return request({
        url: '/api/PmiDictionary/GetByTypeId',
        method: 'get',
        params
    })
}


export function GetSecondList(params) {
    return request({
        url: '/api/CmsType/GetSecondList',
        method: 'get',
        params
    })
}


//门户优秀教官排行
export function GetTearcherList(params) {
    return request({
        url: '/api/Home/GetTearcherList',
        method: 'get',
        params
    })
}

//门户考试中心正式考试
export function GetExamZsList(params) {
    return request({
        url: '/api/Home/GetExamZsList',
        method: 'get',
        params
    })
}
//门户考试中心模拟考试
export function GetExamMyList(params) {
    return request({
        url: '/api/Home/GetExamMyList',
        method: 'get',
        params
    })
}

// 门户样式
// 获取单个数据
export function CmsWebSetGet(params) {
    return request({
        url: '/api/CmsWebSet/Get?deptId=1',
        method: 'get',
        params
    })
}

//门户训练专栏
export function GetTrainList(params) {
    return request({
        url: '/api/Home/GetTrainList',
        method: 'get',
        params
    })
}

//门户训练专栏排行
export function TrainJzTongJi(params) {
    return request({
        url: '/api/Home/TrainJzTongJi',
        method: 'get',
        params
    })
}

//门户微警校
export function GetCourseList(params) {
    return request({
        url: '/api/Home/GetCourseList',
        method: 'get',
        params
    })
}

//首页资源单位统计
export function getDocUnitTongJi(params) {
    return request({
        url: '/api/Home/DocUnitTongJi',
        method: 'get',
        params
    })
}

//首页资源类型统计
export function getDocTypeTongJi(params) {
    return request({
        url: '/api/Home/DocTypeTongJi',
        method: 'get',
        params
    })
}

//首页资源警种统计
export function getDocJzTongJi(params) {
    return request({
        url: '/api/Home/DocJzTongJi',
        method: 'get',
        params
    })
}

//首资源地市统计
export function getDocCityTongJi(params) {
    return request({
        url: '/api/Home/DocCityTongJi',
        method: 'get',
        params
    })
}



export function CmsArticleReadCount(params) {
    return request({
        url: '/api/CmsArticle/ReadCount',
        method: 'get',
        params
    })
}

export function PmiDictionaryGet(params) {
    return request({
        url: '/api/PmiDictionary/Get',
        method: 'get',
        params
    })
}

//门户优秀教官统计
export function GetTearcherTj(params) {
    return request({
        url: '/api/Home/GetTearcherTj',
        method: 'get',
        params
    })
}

//院校链接
export function CmsNavigationLoad(params) {
    return request({
        url: '/api/CmsNavigation/Load',
        method: 'get',
        params
    })
}

//微警校专题和课程列表
export function getCourseList(params) {
    return request({
        url: '/api/CmsSpecial/GetCourseList',
        method: 'get',
        params
    })
}
//资讯列表
export function getArticleList(params) {
    return request({
        url: '/api/CmsSpecial/GetArtByCateId',
        method: 'get',
        params
    })
}
//资源列表
export function getDocumentList(params) {
    return request({
        url: '/api/CmsSpecial/GetDocumentList',
        method: 'get',
        params
    })
}
//问卷列表
export function getPollList(params) {
    return request({
        url: '/api/CmsSpecial/GetPollList',
        method: 'get',
        params
    })
}
//培训班列表
export function getTraintList(params) {
    return request({
        url: '/api/CmsSpecial/GetTraintList',
        method: 'get',
        params
    })
}

//专栏列表
export function getColumnList() {
    return request({
        url: '/api/Home/GetSpecialList',
        method: 'get'
    })
}
//专栏列表
export function getColumnListById(params) {
    return request({
        url: '/api/CmsSpecial/Get',
        method: 'get',
        params
    })
}
//获取首页轮播图片
export function getPicAritlce(params) {
    return request({
        url: '/api/CmsSpecial/GetPicAritlce',
        method: 'get',
        params
    })
}

//获取首页轮播图片
export function getArticleCate(params) {
    return request({
        url: '/api/CmsSpecial/GetArticleCate',
        method: 'get',
        params
    })
}


// 获取专栏新闻 
export function GetArticleCateNew(params) {
    return request({
        url: '/api/CmsSpecial/GetArticleCateNew',
        method: 'get',
        params
    })
}

//首页最新咨询统计
export function HomeNewMesTongJi(params) {
    return request({
        url: '/api/Home/NewMesTongJi',
        method: 'get',
        params
    })
}

// 首页资源统计
export function HomeDocumentTongJi(params) {
    return request({
        url: '/api/Home/DocumentTongJi',
        method: 'get',
        params
    })
}

//首页调训统计
export function HomeTrainTongJi(params) {
    return request({
        url: '/api/Home/TrainTongJi',
        method: 'get',
        params
    })
}

export function GetMoocSpecialList(params) {
    return request({
        url: '/api/Home/GetMoocSpecialList',
        method: 'get',
        params
    })
}

export function getHomeCourseList(params) {
    return request({
        url: '/api/MoocSpecial/GetCourseList',
        method: 'get',
        params
    })
}

export function getDocWkList(params) {
    return request({
        url: '/api/Home/GetDocWkList',
        method: 'get',
        params
    })
}

export function getFloatPage(params) {
    return request({
        url: '/api/Home/GetFloatPage',
        method: 'get',
        params
    })
}


export function CmsPropagateList() {
    return request({
        url: '/api/Home/GetPropagateList',
        method: 'get',
    })
}

//访问量统计
export function getWebCountTJ(params) {
    return request({
        url: '/api/Home/getWebCountTJ',
        method: 'get',
        params
    })
}

//获取用户上传文件记录
export function getUserFileList(params) {
    return request({
        url: '/api/UserFile/Load',
        method: 'get',
        params
    })
}
//保存上传
export function addUserFile(data) {
    return request({
        url: '/api/UserFile/Add',
        method: 'post',
        data
    })
}

//删除上传
export function deleteUserFile(data) {
    return request({
        url: '/api/UserFile/Delete',
        method: 'post',
        data
    })
}
